export default __webpack_public_path__ + "static/desktop-1x-e9240699a970b15cc60b8dfb6d417127.jpeg";